import { render } from "./carInfo.vue?vue&type=template&id=2431b1b3&scoped=true&ts=true"
import script from "./carInfo.vue?vue&type=script&lang=ts"
export * from "./carInfo.vue?vue&type=script&lang=ts"

import "./carInfo.vue?vue&type=style&index=0&id=2431b1b3&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2431b1b3"]])

export default __exports__